import Back from "./Back";
import Body from "./Body";
import Close from "./Close";
import Content from "./Content";
import Footer from "./Footer";
import Header from "./Header";
import Overlay from "./Overlay";
import Root from "./Root";
import Stack from "./stack/Stack";
import Trigger from "./Trigger";
import XClose from "./XClose";

/*
 * NOT RECOMMEND BECAUSE IT WILL AFFECT A11Y
 * Dialog not dismissal by clicking outside: https://github.com/radix-ui/primitives/discussions/1997
 */

export const Dialog = {
  Root, // https://www.radix-ui.com/primitives/docs/components/dialog#root
  Trigger, // https://www.radix-ui.com/primitives/docs/components/dialog#trigger
  Content, // https://www.radix-ui.com/primitives/docs/components/dialog#content
  Stack, // A Content that hosts a stack of views — nested Dialog.Root become sliding panes
  Header,
  Body,
  Footer,
  Close, // https://www.radix-ui.com/primitives/docs/components/dialog#close
  XClose,
  Back, // Steps one view back inside a Stack
  Overlay,
};

export { useDialogStack, type UseDialogStackResult } from "./stack/context";
export { dialogPaneVariants } from "./stack/styles";

export { type DialogBodyProps } from "./Body";
export { type DialogBackProps } from "./Back";
export { type DialogCloseProps } from "./Close";
export { type DialogContentProps } from "./Content";
export { type DialogFooterProps } from "./Footer";
export { type DialogHeaderProps } from "./Header";
export { type DialogOverlayProps } from "./Overlay";
export { type DialogRootProps } from "./Root";
export { type DialogStackProps } from "./stack/Stack";
export { type DialogTriggerProps } from "./Trigger";
export { type DialogXCloseProps } from "./XClose";
